.microFrontendContainer {
  width: 100%;
  height: 100%;

  &.isMobile {
    width: 100%;
    height: 100%;
  }
}
